export default {"src":"/_next/static/media/shipment-white.23f56261.svg","height":15,"width":14};